var styleDataHash = "4e877436";
const injectCss = (() => {
  var css = `@charset "UTF-8";._6aiPI,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.lr8VP{background-color:#fff;border-radius:var(--ricos-settings-whitebox-border-radius,2px);box-shadow:var(--ricos-settings-whitebox-box-shadow,0 4px 8px 0 rgba(0,0,0,.1),0 0 4px 0 rgba(0,0,0,.1));box-sizing:border-box;display:flex;flex-direction:column;gap:8px;max-height:360px;min-height:40px;overflow:hidden;overflow:auto;padding:8px 0}.lr8VP *,.lr8VP :after,.lr8VP :before{box-sizing:inherit}.lr8VP input{box-sizing:border-box}.sV6FO{align-items:center;align-self:center;color:var(--ricos-settings-text-color,var(--ricos-text-color,#212121));cursor:pointer;display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;gap:12px;justify-content:start;min-height:36px;padding-left:12px;padding-right:8px;width:220px}.sV6FO span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.sV6FO.kva4-{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.sV6FO ._4FLYc{border-radius:50%;height:28px;min-height:28px;min-width:28px;overflow:hidden;width:28px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var mention_list_default = {
  "fontElementMap": "_6aiPI",
  "mention_list": "lr8VP",
  "mention_item": "sV6FO",
  "mention_item_selected": "kva4-",
  "avatar": "_4FLYc"
};
export {
  mention_list_default as default,
  injectCss
};
//# sourceMappingURL=mention-list-scss.js.map
